/**
 * 交易管理 通用API
 */
import { post, get } from '../config/$ajax';
import { getErpHost } from '@/utils/domainHelper.js';

const API_HOST = getErpHost();

export const getAjax = (url, data = {}, params = {}) => {
  return get(API_HOST + url, data, params);
};

export const postAjax = (url, data = {}, params = {}) => {
  return post(API_HOST + url, data, params);
};

/**
 * 获取订单处理列表
 * @params { Object }
 * @returns { Object }
 */
export async function getTradeSearch(params) {
  const { data = {} } = await postAjax('trade/search', params);
  return data;
}
/**
 * 获取订单处理列表总数
 * @param {*} params 
 * @returns 
 */
export async function getTradeSearchCount(params) {
  const { data = {} } = await postAjax('trade/search/count', params);
  return data;
}


export async function caigouTest(){
  return getAjax('/caigou/supplier/list');
}

/**
 * 获取订单这边所有店铺
 */
export async function getShopList(shopTotal = 500) {
  let json = await getAjax('/shop/info/light', {
    pageNo: 1,
    pageSize: shopTotal,
  }, { isNeedLoading: false })

  json = json || {};
  let tempData = json.data || {},
      tempShops = tempData.list || [];
  return tempShops.map(shop => {
    let shortName = shop.title;
    if (!!shop.simpleTitleConfig && shop.shortTitle) {
      shortName = shop.shortTitle;
    }
    shop._title = shop.title;
    shop.shortTitle = shop.title = shortName;
    return shop;
  });
}